require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/opaque_building_table.template.html');
var RowElement = require('text-loader!../templates/row_opaque_building.template.html');

var TheView = GenericView.extend({
    el: '#opaque_table_container',
    tagName: 'div',
    template: Handlebars.compile(Template),
	rowElement: Handlebars.compile(RowElement),
	superInitialize: GenericView.prototype.initialize,
	initialize: function (options) {
		this.render();
	},
	superRender: GenericView.prototype.render,
	render: function () {
		var self = this;
		this.superRender();
		this.$el.html(this.template);
        this.addRow();

	},
	events: {
		"click #add_opaque_button": "addRow",
		"click #delete_opaque_button": "deleteRow",
		"change .building_element": "checkValueOfBuildingElement"
	},
	addRow: function()
	{
		$("#opaque_building_elements").append(this.rowElement());
		$(window).trigger("change-building-rows");
	},
	deleteRow: function(event)
	{
	    var row = $(event.currentTarget);
	    row.parent().parent().remove();
	    $(window).trigger("change-building-rows");
	},
	checkValueOfBuildingElement: function(e) {
	    var element = $(e.currentTarget);
	    var currentRow = element.parent().parent();

        if (element.val() == "Floor" || element.val() == "BasementWall") {
	        $(currentRow).find(".a_sol option").prop("disabled", true);
	        $(currentRow).find(".a_sol").val("None");
        } else {
            $(currentRow).find(".a_sol option").prop("disabled", false);
        }
	},
	clearView: function()
	{
		this.$el.html("");
	}
});

module.exports = TheView;